import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { PositionNotFountError } from "../../domain/errors/position-not-found-error";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Position } from "../../domain/models/position-model";
import {
  LoadPositionList,
  LoadPositionListParams,
} from "../../domain/usecases/load-position-list";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadPositionList implements LoadPositionList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async load(params?: LoadPositionListParams): Promise<Position[]> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
      params,
    });

    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.noContent:
        throw new PositionNotFountError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      default:
        throw new UnexpectedError();
    }
  }
}
